<template>
    <v-layout row wrap>
        <loading-component :value="loading"/>
        <v-flex xs12>
            <v-chip v-for="(_,key) of categories" :color="categories[key].color" style="font-weight: bold">
                {{key}}
            </v-chip>
        </v-flex>
        <v-flex xs4>
            <bar-chart :x-labels="weekStarts"
                       :datasets="avgBookings"
            />
        </v-flex>
        <v-flex xs4>
            <bar-chart :x-labels="weekStarts"
                       :datasets="activeCaptains"
            />
        </v-flex>
        <v-flex xs4>
            <v-flex xs12 class="pa-2">
                <choose-date v-model="start" label="From"/>
            </v-flex>
            <v-flex xs12 class="pa-2">
                <choose-date v-model="end" label="To"/>
            </v-flex>
        </v-flex>
        <v-flex xs12>
            <v-data-table
                    :headers="headers"
                    :items="sortedAndPackedData"
                    :pagination="{
                    rowsPerPage: -1
                    }"
                    disable-initial-sort

                    class="elevation-1"
            >
                <template v-slot:items="props">
                    <td>{{ props.item.name }} #{{props.item.id}}</td>
                    <td class="indicator" v-for="week of weekStarts"
                        :style="'background-color: ' + Object.values(categories).filter(i => i.checker(getBookingPerWeek(props.item,week)))[0].color">
                        {{ getBookingPerWeek(props.item,week) }}
                    </td>
                </template>
            </v-data-table>
        </v-flex>

    </v-layout>
</template>

<script>
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import moment from "moment";
    import LoadingComponent from "@/components/LoadingComponent";
    import BarChart from "@/components/widgets/statistic/BarChart";

    export default {
        components: {LoadingComponent, ChooseDate, BarChart},
        name: "WeeklyPresent",
        title: "Weekly Present Captains",
        data() {
            return {
                loading: false,
                start: moment().startOf('month').format("YYYY-MM-DD"),
                end: moment().format("YYYY-MM-DD"),
                data: []
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            async getData() {
                this.loading = true;
                const {data: {data}} = await this.axios.get(this.api.ACTIONS.PRESENT_CAPTAINS, {params: this.params});
                this.data = data;
                this.loading = false;
            },
            getBookingPerWeek(captain, weekStart) {
                const week = parseInt(moment(weekStart).format("WW"));
                const captainWeek = captain.weeks.filter(i => i.week_number === week)[0];
                return !captainWeek ? 0 : captainWeek.bookings_count;
            }
        },
        watch: {
            params() {
                this.getData();
            }
        },
        computed: {
            avgBookings() {
                return [
                    {
                        label: "Avg Bookings Per Captain",
                        data: this.weekStarts.map(week => {
                            const data = this.sortedAndPackedData.reduce((sum, item) => ({
                                sum: this.getBookingPerWeek(item, week) + sum.sum,
                                count: sum.count + (this.getBookingPerWeek(item, week) > 0)
                            }), {sum: 0, count: 0});
                            return !data.count ? 0 : (data.sum / data.count).toFixed(2);
                        }),
                        fill: false,
                        backgroundColor: "#4444F7",
                        borderColor: "#FFF",
                        borderWidth: 1
                    }
                ];
            },
            activeCaptains() {
                return [
                    {
                        label: "Active Captains",
                        data: this.weekStarts.map(week => {
                            return this.sortedAndPackedData.reduce((count, item) => (this.getBookingPerWeek(item, week) > 0) + count, 0);
                        }),
                        fill: false,
                        backgroundColor: "#44F744",
                        borderColor: "#FFF",
                        borderWidth: 1
                    }
                ];
            },
            weekStarts() {
                let firstWeekStart = moment(this.start).startOf('week');
                const weeksStarts = [];
                while (firstWeekStart <= moment(this.end).startOf('week')) {
                    weeksStarts.push(firstWeekStart.format("YYYY-MM-DD"));
                    firstWeekStart.add(1, 'week');
                }
                return weeksStarts;
            },
            headers() {
                const weeksStarts = this.weekStarts;
                return [
                    {text: 'Captain', value: 'captain_name'},
                    ...weeksStarts.map(week => ({text: week, value: 'week_' + week}))
                ]
            },
            sortedAndPackedData() {
                const grouped = Object.values(this.data.reduce(
                    (result, captain) => {
                        if (!result[captain.captain_id])
                            result[captain.captain_id] = {
                                id: captain.captain_id,
                                name: captain.captain_name,
                                weeks: []
                            };
                        result[captain.captain_id].weeks.push(
                            captain
                        );
                        return result;
                    },
                    {}));
                return grouped.sort((a, b) => {
                    if (a.weeks.length < b.weeks.length)
                        return 1;
                    else if (a.weeks.length > b.weeks.length)
                        return -1;
                    else
                        return b.weeks.reduce((j, k) => j + k.bookings_count, 0) - a.weeks.reduce((j, k) => j + k.bookings_count, 0)
                });
            },
            params() {
                const params = new URLSearchParams();
                params.append("start", this.start + " 00:00:00");
                params.append("end", this.end + " 23:59:59");
                return params;
            },
            categories() {
                return {
                    "No Bookings": {
                        checker: bookings_count => !bookings_count,
                        color: "#F74444"
                    },
                    "Below 25 Bookings": {
                        checker: (bookings_count) => bookings_count < 25 && bookings_count > 0,
                        color: "#F7F744"
                    },
                    "Between 25 And 50 Bookings": {
                        checker: (bookings_count) => !!bookings_count && bookings_count >= 25 && bookings_count <= 50,
                        color: "#44F744"
                    },
                    "+50 Bookings": {
                        checker: (bookings_count) => !!bookings_count && bookings_count > 50,
                        color: "#4444F7"
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>